import React from 'react'

function Signup() {
  return (
    <div>
      <h1>signup</h1>
    </div>
  )
}

export default Signup
